import React, { useState } from 'react';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../offer-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useOfferTags from '../../hooks/useOfferTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Competencies(props) {
  const { offer } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const offerGuidances = useOfferTags(offer, TagTypes.Guidance, timestamp);

  let subtitle = '';

  if (offerGuidances.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = offerGuidances.data.map(function(offerGuidance) {
      return offerGuidance.data.name;
    }).join(', ');
  }

  return (
    <DataCard
      title="Professional Competencies"
      icon={BriefcaseIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(offer).COMPETENCIES)}
    />
  );
};
